module.exports = __webpack_public_path__ + "img/Moving-Mountains-03-360px.gif";